export const ACTUACION_CONTRACTUAL_LABELS = {
  // Navigation
  administration: 'Administración',
  actuacionesContractuales: 'Actuaciones Contractuales',

  // Actions
  createActuacionContractual: 'Crear Actuación Contractual',
  editActuacionContractual: 'Editar Actuación Contractual',
  save: 'Guardar',
  cancel: 'Cancelar',
  close: 'Cerrar',

  // Form fields
  actuacionId: 'ID de Actuación Contractual',
  tipo: 'Tipo',
  estado: 'Estado',

  // Table
  tableId: 'ID',
  tableTipo: 'Tipo',
  tableStatus: 'Estado',
  tableActions: 'Acciones',

  // Messages
  loadingActuacionesContractuales: 'Cargando actuaciones contractuales...',
  noActuacionesContractuales: 'No hay actuaciones contractuales disponibles',

  // Tooltips
  tooltipEdit: 'Editar actuación contractual',
  tooltipView: 'Ver detalles de la actuación contractual'
} as const;
